import { useState, useEffect, useCallback } from "react";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const TableFilterForm = ({
  handleSubmit = () => {},
  handleSearch = (input = "", accessors = []) => {},
  clearAll = () => {},
  loading = false,
  accessors = [],
}) => {
  const { t } = useTranslation("Shared");
  const [input, setInput] = useState("");

  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setInput("");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleSearch(input, accessors);
    //eslint-disable-next-line
  }, [input]);

  return (
    <Form className="d-flex align-items-center my-3" onSubmit={handleSubmit}>
      <Form.Control
        onChange={(e) => setInput(e.target.value)}
        value={input}
        placeholder="Search"
        className="w-25"
        disabled={loading}
        size="sm"
      />
      <Button
        className="ms-2"
        variant="outline-secondary"
        name="clear"
        onClick={() => {
          clearAll();
          setInput("");
        }}
        disabled={loading}
        size="sm"
      >
        {t("buttons.clear_filters")}
      </Button>
    </Form>
  );
};

export default TableFilterForm;
